import { createContext, useContext } from 'react';
const PromptContainerPopoverRootContext = createContext(null);
export const PromptContainerPopoverRootProvider = PromptContainerPopoverRootContext.Provider;
export function usePromptContainerPopoverRoot() {
    return useContext(PromptContainerPopoverRootContext);
}
